// extracted by mini-css-extract-plugin
module.exports = {"list":"ScrapModal_list__2VBbq","amountToScrap":"ScrapModal_amountToScrap__KTZB8","availableBalance":"ScrapModal_availableBalance__1nMF_","counter":"ScrapModal_counter__cpNRv"};